import {
  DynamicContents,
  DynamicContentsItem,
} from '../../../app-kit/components/DynamicContent/types';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { usePropertyPageModalContext } from '../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { DisclaimerIcon } from '../../../app-kit/components/DisclaimerIcon/DisclaimerIcon';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';

interface NearbySchoolsBrick {
  title: string;
  subtitle?: string | null;
  subtitleWithDynamicContent?: DynamicContents<DynamicContentsItem> | null;
}

export const NearbySchoolsBrick: FunctionComponent<PropsWithChildren<NearbySchoolsBrick>> = ({
  title,
  subtitle,
  children,
  subtitleWithDynamicContent,
}) => {
  const { displayModal } = usePropertyPageModalContext();

  return (
    <ContentBrick
      title={title}
      subtitle={subtitle}
      subtitleWithDynamicContent={subtitleWithDynamicContent}
      headerChildren={
        <DisclaimerIcon
          title="Open Nearby Schools Disclaimer"
          onClick={() => {
            displayModal({ name: 'nearbySchoolsDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: 'property_page__nearby_schools_brick___disclaimer_link',
            });
          }}
        />
      }
    >
      {children}
    </ContentBrick>
  );
};
